import { FilterOutlined, SearchOutlined, UserAddOutlined } from '@ant-design/icons';
import { Button, Drawer, Input, Space } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Outlet, useLoaderData, useNavigate } from 'react-router-dom';
import { getVatList } from '../../api/settings/vatType.js';
import { SelectedFilters } from '../../components/data/selected-filters.jsx';
import VatFilterForm from '../../components/form/vat-filter/vat-filter.jsx';
import { Page } from '../../components/page';
import { InfiniteTable } from '../../components/table';
import { useFetch } from '../../hooks';
import { generateRouteUrl } from '../../library/constants/routes.js';
import { vatListColumns } from '../../library/constants/tableColumns/vatListColumns.js';
import { searchParamsToObject } from '../../library/helpers/index.js';

const FILTER_NAMES = {
  entity_id: 'Entity',
  percentage: 'Percentage',
};

function VATList(props) {
  const { title } = props;
  const initialData = useLoaderData()
  const navigate = useNavigate()
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [list, hasMore, isLoading, searchParamsParsed, {
    setSort,
    setFilters,
    loadMore
  }] = useFetch({ initialData })

  return (
    <Page title={title}
      summary={initialData?.meta?.totalCount ? `(${initialData?.meta?.totalCount} Records)` : '(No Records)'}
      header={(
        <>
          <div></div>
          <Space.Compact style={{ width: '100%', maxWidth: '400px' }}>
            <Input.Search
              placeholder="Search"
              defaultValue={searchParamsParsed?.filter?.search}
              prefix={<SearchOutlined />}
              onChange={(e) => setFilters({ 'search': e.target.value })}
              allowClear
            />
            <Button onClick={() => setFiltersVisible(v => !v)} icon={<FilterOutlined />}>
              Filters
            </Button>
          </Space.Compact>
          <Button type="primary" onClick={() => { navigate(generateRouteUrl('VATCreate')) }} icon={<UserAddOutlined />}>Add VAT Type</Button>
        </>
      )}
      subHeader={initialData.meta?.filters && Object.keys(initialData.meta.filters).length > 0 && (
        <SelectedFilters filters={initialData.meta.filters} filterNames={FILTER_NAMES} updateFilters={setFilters} />
      )}
    >
      <Drawer title="Filter VAT Types" open={filtersVisible} onClose={() => setFiltersVisible(false)}>
        <VatFilterForm
          key={JSON.stringify(searchParamsParsed?.filter)}
          data={searchParamsParsed?.filter}
          onFinish={(filters) => {
            setFilters(filters);
            setFiltersVisible(false);
          }}
        />
      </Drawer>
      <InfiniteTable
        columns={vatListColumns}
        data={list}
        rowKey="id"
        onRowClick={(_, { id }) => navigate(generateRouteUrl('VATDetails', {
          id
        }))}
        isLoading={isLoading}
        onChange={setSort}
        hasMore={hasMore}
        loadMore={loadMore}
      />
      <Outlet />
    </Page>
  )
}

VATList.Loader = async ({ request }) => {
  const url = new URL(request.url)
  const { filter, page, sort } = searchParamsToObject(url.searchParams)
  const { data, meta } = await getVatList({ filter, page, ...sort })
  return { data, meta }
}

VATList.propTypes = {
  title: PropTypes.string,
}

export default VATList
